module.exports = __webpack_public_path__ + "media/images/icons/SVG/072-1a89efe798b6624784c86d8c64dc6236.svg";